import React, { useState } from "react";

export default function LineChart({ data, color = "#1a73e8", height = 180 }) {
  const [hoverIdx, setHoverIdx] = useState(null);
  const max = Math.max(...data.map((d) => d.value), 1) * 1.15;
  const stepX = data.length > 1 ? 100 / (data.length - 1) : 0;

  const points = data.map((d, i) => ({
    x: data.length > 1 ? i * stepX : 50,
    y: 100 - (d.value / max) * 100,
    value: d.value,
    label: d.label
  }));

  const pathD = points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
  const areaD = points.length ? `${pathD} L ${points[points.length - 1].x} 100 L ${points[0].x} 100 Z` : "";

  return (
    <div className="relative" style={{ height, marginBottom: 24 }}>
      <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full">
        {[0, 25, 50, 75, 100].map((gy) => (
          <line
            key={gy}
            x1="0"
            y1={gy}
            x2="100"
            y2={gy}
            stroke="currentColor"
            strokeWidth="0.4"
            vectorEffect="non-scaling-stroke"
            className="text-[#e8eaed] dark:text-[#3c4043]"
          />
        ))}
        {areaD && <path d={areaD} fill={color} opacity="0.08" />}
        {pathD && <path d={pathD} fill="none" stroke={color} strokeWidth="1.6" vectorEffect="non-scaling-stroke" strokeLinejoin="round" strokeLinecap="round" />}
      </svg>

      {/* HTML overlay for point markers so they stay perfectly circular regardless of chart aspect ratio */}
      <div className="absolute inset-0">
        {points.map((p, i) => (
          <div
            key={i}
            className="absolute -translate-x-1/2 -translate-y-1/2"
            style={{ left: `${p.x}%`, top: `${p.y}%` }}
            onMouseEnter={() => setHoverIdx(i)}
            onMouseLeave={() => setHoverIdx(null)}
          >
            <div className="w-2.5 h-2.5 rounded-full border-2 border-white dark:border-[#303134] cursor-pointer shadow-sm" style={{ backgroundColor: color }} />
            {hoverIdx === i && (
              <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 px-2 py-1 rounded-lg bg-[#202124] text-white text-[10px] font-semibold whitespace-nowrap shadow-lg z-10">
                {p.value} · {p.label}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="absolute top-full mt-1.5 left-0 right-0 flex justify-between px-0.5">
        {data.map((d, i) => (
          <span key={i} className="text-[10px] text-[#9aa0a6]">
            {d.label}
          </span>
        ))}
      </div>
    </div>
  );
}
